import { FieldMap, FieldTypes } from '@hb/shared'

export const dotPhraseTemplateField: FieldMap = {
  name: 'Dot Phrase Template',
  children: {
    keyword: {
      type: FieldTypes.TEXT,
      placeholder: 'Keyword — providers type .keyword + Tab to expand (e.g. hpi, ros)',
    },
    body: {
      type: FieldTypes.TEXTAREA,
      placeholder: 'Full expansion text — use [placeholder] for customizable parts',
    },
    description: {
      type: FieldTypes.TEXT,
      placeholder: 'Short description shown in the picker (optional)',
      optional: true,
    },
  },
}
